__turbopack_context__.v({
  "className": "nunito_sans_8b997e82-module__OwaJLW__className",
});
